import {AuthService} from "./AuthService";

export class SearchDiagnosticsService {

    // GET admin/search_diagnostics/product/?product_id=<id>
    // -> {queries[], pages[], results[], counts, run} or null when the product
    // has never been searched. `run` is null once the run's 90-day TTL has expired.
    getProductSearchDiagnostics(productId) {
        return AuthService.apiGet(`admin/search_diagnostics/product/?product_id=${productId}`)
            .then(res => res.data.data);
    }

    // GET admin/search_diagnostics/campaign/?campaign_id=<id>
    // -> {run, products, counts, top_broken_hosts[]} for the campaign's LATEST run only.
    getCampaignSearchSummary(campaignId) {
        return AuthService.apiGet(`admin/search_diagnostics/campaign/?campaign_id=${campaignId}`)
            .then(res => res.data.data);
    }

    // POST admin/search_diagnostics/retry/ {campaign_id, hosts} -> the scraping request.
    // Re-fetches only the URLs those hosts failed on; it never searches again.
    startRetry(campaignId, hosts) {
        return AuthService.apiPost('admin/search_diagnostics/retry/',
            {campaign_id: campaignId, hosts})
            .then(res => res.data.data);
    }

    // GET admin/search_diagnostics/product_sites/?product_id=<id>
    // -> [{host, target, status, queries[], pages[], results[], counts, searched_at, run}],
    // newest first. Only sites this product was actually searched on; `run` is null once
    // its 90-day TTL expired.
    getProductSiteSearchDiagnostics(productId) {
        return AuthService.apiGet(`admin/search_diagnostics/product_sites/?product_id=${productId}`)
            .then(res => res.data.data);
    }

    // GET admin/search_diagnostics/campaign_sites/?campaign_id=<id>
    // -> [{host, trigger, totals, skipped, budget, all_zero_results, sample_problems, ...}],
    // one row per site: that site's LATEST run.
    getCampaignSiteSearchSummary(campaignId) {
        return AuthService.apiGet(`admin/search_diagnostics/campaign_sites/?campaign_id=${campaignId}`)
            .then(res => res.data.data);
    }
}
